export type MyJFrogTheme = "DEFAULT" | "ALTERNATIVE";

export enum ViewContext {
  IP_ALLOWLIST = "IP_ALLOWLIST",
  PRIVATE_CONNECTIONS = "PRIVATE_CONNECTIONS",
  GEOLOCATION_RESTRICTIONS = "GEOLOCATION_RESTRICTIONS",
}
